import { render } from "./UpgradeConfig.vue?vue&type=template&id=10ba05d2&scoped=true"
import script from "./UpgradeConfig.vue?vue&type=script&lang=js"
export * from "./UpgradeConfig.vue?vue&type=script&lang=js"

import "./UpgradeConfig.vue?vue&type=style&index=0&id=10ba05d2&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ba05d2"]])

export default __exports__